import ExpressionPage from '../store/schema/ExpressionPage';
import ExpressionPickerViewState from '../store/schema/ExpressionPickerViewState';
import GifSearchMethod from '../store/schema/GifSearchMethod';
import getPopularEmoji from '../utils/getPopularEmoji';
import matchEmoji from '../utils/matchEmoji';
import matchGif from '../utils/matchGif';
import { action } from 'satcheljs/lib/legacy';

export default action('updateSearch')(async function updateSearch(
    state: ExpressionPickerViewState,
    searchTerm: string,
    searchMethod: GifSearchMethod,
    gifDummyCallback?: () => void
) {
    if (searchTerm === state.searchTerm) {
        // If the search query match the term in the searchbox, the results are already up to date
        return;
    }

    state.isSearching = true;
    state.searchTerm = searchTerm;

    if (searchTerm) {
        // Perform search and update GIFs and emoji with results accordingly
        state.gifPickerViewState.gifResults = await matchGif(
            searchTerm,
            searchMethod,
            gifDummyCallback
        );
        state.emojiPickerViewState.emojiResults = matchEmoji(searchTerm);
        if (state.page !== ExpressionPage.Gifs) {
            state.numSearchesToInsertEmoji++;
        }
    } else {
        // Reset search results on empty query
        state.gifPickerViewState.gifResults = null;
        state.emojiPickerViewState.emojiResults = getPopularEmoji();
    }

    state.isSearching = false;
});
